import * as HttpService from 'services/http.service';
import { GET_SEARCH_SUGGESTIONS } from 'services/url.service';

export const getSuggestions = (text) =>
  HttpService.getWithoutAuth(GET_SEARCH_SUGGESTIONS(text));

export default getSuggestions; // TODO: Remove after add another export function or var.
